__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "contractor_management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.14.1", () => (Promise.all([__webpack_require__.e(221), __webpack_require__.e(509), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(9509))))));
			register("@azure/msal-browser", "4.30.0", () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(5370))))));
			register("@azure/msal-react", "3.0.29", () => (Promise.all([__webpack_require__.e(860), __webpack_require__.e(212), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(9479))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(642), __webpack_require__.e(696)]).then(() => (() => (__webpack_require__(8642))))));
			register("@unity/auth-lib", "3.0.1", () => (Promise.all([__webpack_require__.e(355), __webpack_require__.e(212), __webpack_require__.e(950), __webpack_require__.e(69)]).then(() => (() => (__webpack_require__(1355))))));
			register("@unity/react-elements-lib", "11.1.35", () => (Promise.all([__webpack_require__.e(929), __webpack_require__.e(212), __webpack_require__.e(714)]).then(() => (() => (__webpack_require__(3929))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(635), __webpack_require__.e(212), __webpack_require__.e(714), __webpack_require__.e(616)]).then(() => (() => (__webpack_require__(635))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(475), __webpack_require__.e(212), __webpack_require__.e(714)]).then(() => (() => (__webpack_require__(7475))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};